const Data = [
    {
        title: 'BloomTech Labs',
        content: [
            {
                smallTitle: 'Family Promise of Spokane (Full Stack Developer) - React | Node | Redux Toolkit | AntDesign',
                text: [
                    'Collaborated in Agile development environment with product manager and provided feedback on pull requests using GitHub, Jira, and Slack',
                    'Created and implemented a mock data source to replicate Node API using JavaScript so that team could build UI/UX components and the API simultaneously',
                    'Designed and built the Resources page using AntDesign and React with iterative cards and display modals to facilitate easy resource management for stakeholders',
                    'Programmed a custom filter button on the Resources page with search functionality to easily sort cards and access relevant data for each resource',
                    'Redesigned redux store using Redux Toolkit to provide easier access and implementation of redux state across components and pages',
                    'Produced slices of state for clients and users to supply data from Auth0 and backend so that case administrators can easily access a list of clients',
                ],
                github: 'https://github.com/esmodea/family-promise-case-mgmt-fe'
            },
            {
                smallTitle: 'Coder Heroes',
                text: [
                    'Altered and designed layout of Admin Dashboard menu using Figma and AntDesign menus to ease admin user flow from page to page',
                    'Designed data flow model for front end for documentation and ease of understanding user flow throughout the site so developers could more efficiently plan implementation of use cases',
                ],
                github: 'https://github.com/esmodea/coder-heroes-fe'
            }
        ]
    },
    {
        title: 'Bloomtech Projects',
        content: [
            {
                smallTitle: 'Web-Module-Project-Redux (Full Stack Developer) - React | Node | Redux',
                text: [
                    'Modified a single page application so it works with React-Redux to handle stateful components so that the functionality can be used from any component on the page',
                    'Wrote functionality to delete and add new movies from the movie list using a reducer function to keep the state immutable'
                ],
                github: 'https://github.com/esmodea/web-module-project-redux'
            },
            {
                smallTitle: 'Advanced-State Challenge (Full Stack Developer) - React | Node',
                text: [
                    'Created the functionality on a website with React.js to match a stateful single page example application using React Router and best practices',
                    'Included components and stateful code to track the position of items on the page using React Redux to handle state'
                ],
                github: 'https://github.com/esmodea/web-sprint-challenge-advanced-state',
                website: 'https://advanced-state-wheel.herokuapp.com/'
            },
            {
                smallTitle: 'Adding-Data-Persistence Challenge (Full Stack Developer) - Express.js | Node',
                text: [
                    'Coded endpoints for a rudimentary SQLite database in Express.js to allow RESTful API interaction via http requests',
                    'Created a migrations file to allow rollbacks and new migrations to the database schema for potential future updates to data structure'
                ],
                github: 'https://github.com/esmodea/web-sprint-challenge-adding-data-persistence'
            },
        ]
    },
    {
        title: 'Odin Projects',
        content: [
            {
                smallTitle: 'Odin Project Etch-A-Sketch (Full Stack Developer) - HTML | CSS | JS',
                text: [
                    'Set up a script to create divs with event listeners so that users can press a button and then hover the mouse over the canvas and create pixel art of various resolutions',
                    'Designed a simple UI for the user to interact with the canvas creation and select the resolution with a slider using an HTML form'
                ],
                github: 'https://github.com/esmodea/Etch-A-Sketch',
                website: 'https://esmodea.github.io/Etch-A-Sketch/'
            },
            {
                smallTitle: 'Odin Project Rock Paper Scissors (Full Stack Developer) - HTML | CSS | JS',
                text: [
                    'Coded a program to select rock, paper or scissors with Math.random and compare the answer to the user’s selection using a JavaScript if-then statement',
                    'Designed the UI in CSS and JavaScript to allow the user to select their choice with a click event-listener attached to a button, and to show a scoreboard and game history'
                ],
                github: 'https://github.com/esmodea/RockPaperScissors',
                website: 'https://esmodea.github.io/RockPaperScissors/'
            }
        ]
    },
    {
        title: 'Education',
        content:[
            {
                smallTitle: 'BloomTech (Lambda School), Graduate, Full Time Program, Full Stack Web Development'
            },
            {
                smallTitle: 'The Odin Project, Foundational JavaScript'
            }
        ]
    } 
]

export default Data;